import * as React from "react";

const Alert = function(props) {
  return (
    <div className={"alert alert-" + props.type} role="alert">
      {props.message}
    </div>
  );
};

export default Alert;
